/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot, hydrateRoot } from "react-dom/client";
import { Main_Layout } from "./App";

function start() {
  const root = createRoot(document.getElementById("root")!);
  root.render(<Main_Layout/>);
}




if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
